import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "max-width",
  style: {"max-width":"400px"}
}
const _hoisted_2 = { class: "octo-gradient-purple-color fw-b fs-larger" }

import { IonCol, IonGrid, IonRow, IonSelectOption } from "@ionic/vue";
import { computed, onMounted, ref } from "vue";

import InputAmount from "@/components/input/InputAmount.vue";
import ButtonBase from "@/components/button/ButtonBase.vue";
import ImageProduct from "@/components/various/ImageProduct.vue";
import SelectBase from "@/components/selects/SelectBase.vue";

import { isApp } from "@/functions/enviroment";

import { PromotionOld, PromotionVariant } from "@/types/notification";
import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { PromotionProductEmits } from "@/types/emits";
import { useUserStore } from "@/stores/user";
import { PERMISSION_KEY } from "@/types/user";
import CardDelivererReduced from "@/components/card/CardDelivererReduced.vue";
import { Supplier } from "@/types/supplier";
import { useSupplierStore } from "@/stores/suppliers";


export default /*@__PURE__*/_defineComponent({
  __name: 'PromotionProduct',
  props: {
    product: {}
  },
  emits: ["details", "back", "amount", "addCart"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const supplierStore = useSupplierStore()

const evaluateAmount = (): number => {
    if (!props.product) return 1

    return props.product.amountStep ?? 1
}

const amount = ref<number>(evaluateAmount())
const variantId = ref<string>('')

const isMax = computed<boolean>(() => {
    if (props.product.amountMax) return amount.value <= props.product.amountMax

    return true
})
const isMultiple = computed<boolean>(() => {
    return (amount.value % (props.product.amountStep ?? 1)) === 0
})
const variant = computed<PromotionVariant | undefined>(() => {
    const variantValue = props.product.variants?.find(variant => variant.supplierItem?.id === variantId.value)

    return variantValue
})
const isProducts = computed<boolean>(() => (props.product.variants?.length ?? 0) > 1)
const suppliers = computed<Supplier[]>(() => {
    if (!props.product || !props.product.supplierIds?.length) return []

    const informationSuppliers: Supplier[] = []
    for (const supplierId of props.product.supplierIds) {
        const participatingSupplier = supplierStore.supplierById(supplierId)
        if (!participatingSupplier) continue
        informationSuppliers.push(participatingSupplier)
    }
    return informationSuppliers
})

const addCart = (): void => {
    if (!variant.value) return;

    emit('addCart', { product: variant.value, amount: amount.value })
}

onMounted(() => {
    variantId.value = props.product.variants ? props.product.variants[0]?.supplierItem?.id ?? '' : ''
})

const verticalVersion = ref<boolean>(isApp() && !window.matchMedia("(orientation: landscape)").matches)
window.addEventListener('orientationchange', () => verticalVersion.value = isApp() && !window.matchMedia("(orientation: landscape)").matches)
window.addEventListener('resize', () => verticalVersion.value = isApp() && !window.matchMedia("(orientation: landscape)").matches)

return (_ctx: any,_cache: any) => {
  return (__props.product)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "p-relative light-light-background max-size",
        style: _normalizeStyle(!verticalVersion.value ? 'padding-inline: 4.25rem;' : '')
      }, [
        (verticalVersion.value)
          ? (_openBlock(), _createBlock(ImageProduct, {
              key: 0,
              "image-link": __props.product.imageLink
            }, null, 8, ["image-link"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(IonGrid), {
          class: _normalizeClass(["purple-purple-color d-flex flex-d-c flex-grow-1 max-width", {'max-height': !verticalVersion.value}])
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRow), { class: "max-height" }, {
              default: _withCtx(() => [
                (!verticalVersion.value)
                  ? (_openBlock(), _createBlock(_unref(IonCol), {
                      key: 0,
                      class: "center max-height-100"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ImageProduct, {
                          "image-link": __props.product.imageLink
                        }, null, 8, ["image-link"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(IonCol), {
                  class: _normalizeClass(["center", { 'mt-3': _unref(isApp)() }])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), { class: "fs-12 grey1-grey1-color" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('label.availableFrom')) + ": ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suppliers.value, (supplier) => {
                        return (_openBlock(), _createBlock(_unref(IonRow), {
                          key: supplier.id,
                          class: "pb-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(CardDelivererReduced, { supplier: supplier }, null, 8, ["supplier"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_2, _toDisplayString(__props.product.name), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(__props.product.description), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_unref(useUserStore)().permission[_unref(PERMISSION_KEY).CART_ADD])
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (isProducts.value)
                              ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonCol), null, {
                                      default: _withCtx(() => [
                                        _createVNode(SelectBase, {
                                          modelValue: variantId.value,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((variantId).value = $event)),
                                          class: "grey1-grey1-color grey4-grey4-background",
                                          style: {"--original-background":"var(--ion-color-grey4)"},
                                          placeholder: _ctx.$t('placeholder.selectSize')
                                        }, {
                                          options: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.variants, (variant) => {
                                              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                                key: variant.id,
                                                value: variant.supplierItem?.id
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(variant.variation), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ]),
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('modal.selection')) + " ", 1)
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "placeholder"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(IonRow), { class: "mt-3" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonCol), { size: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(InputAmount, {
                                      "amount-step": props.product.amountStep,
                                      modelValue: amount.value,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((amount).value = $event)),
                                      onChange: _cache[2] || (_cache[2] = ($event: any) => (emit('amount', amount.value)))
                                    }, null, 8, ["amount-step", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (!isMultiple.value)
                              ? (_openBlock(), _createBlock(_unref(IonRow), { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonCol), { class: "coral-coral-color fs-small center-x" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('label.multipleAmount', { target: props.product.amountStep ?? 1 })), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (!isMax.value)
                              ? (_openBlock(), _createBlock(_unref(IonRow), { key: 2 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonCol), { class: "coral-coral-color fs-small center-x" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('label.maxAmount', { target: props.product.amountMax })), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(IonRow), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonCol), { class: "center" }, {
                                  default: _withCtx(() => [
                                    _createVNode(ButtonBase, {
                                      color: _unref(ION_VARIANT).CORAL,
                                      class: "ml-3 mr-3 fw-b wrap-button tt-none max-width",
                                      onClick: addCart,
                                      disabled: !isMultiple.value || !isMax.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('modal.addCart')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["color", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ], 4))
    : _createCommentVNode("", true)
}
}

})